import React from 'react'
import { Row, Col, Button, Card } from 'react-bootstrap'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Zoom } from 'react-awesome-reveal';
// import { ReceiptCutoff, CalendarCheck } from 'react-bootstrap-icons';

function SkeletonOrderDetail() {
    
    return (
        <SkeletonTheme baseColor="#cecdcd" highlightColor="#e2dfdf">

            <Col xs={12} lg={7} className="pr-lg-0">
                {/* repeat start */}



                <Card className="w-100 rounded-4 mb-2">
                    <Card.Body className="p-2">
                        <Row>
                            <Col xs={12} lg={7} xl={8}>
                                <Row>
                                    <Col xs="auto">
                                        <Skeleton width={100} height={100} />
                                    </Col>

                                    <Col className="pr-0 my-auto" style={{ lineHeight: '23px' }}>
                                        <div className="font-weight-bold mb-1">  <Skeleton width={100} count={3} /> </div>

                                    </Col>
                                    <Col xs={12}>
                                        <Row className="border-top pt-2 mx-0 mt-2">
                                            <Col xs={12} className='pr-1 text-muted text-small pb-1'>
                                                {/* <CalendarCheck size={13} /> */}
                                                  تاریخ استفاده از تفریح :
                                                <span className='pr-1 text-dark font-weight-bold '> <Skeleton width={100}/> </span>
                                            </Col>

                                            <Col xs={8} className="pr-1 text-muted text-small pb-1">
                                                {/* <ReceiptCutoff size={13} />  */}
                                                 وضعیت :
                                                <span className='pr-1 text-danger font-weight-bold '  > <Skeleton width={50}/>  </span>
                                            </Col>
                                            <Col xs={4} className='d-flex justify-content-end'>
                                               
                                                    <div className='text-center rounded-4 border border-danger px-3 py-0 text-small text-danger cursor-pointer'  >کنسل</div>
                                                



                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>

                            <Col xs={12} lg={5} xl={4} className=" mt-2 my-lg-auto text-left">
                                <div className="rounded-4 bg-light-blue py-4 border">
                                    <Row className="mx-0">
                                        <Col xs={4} lg={12} className="text-center px-0 px-lg-3 py-lg-2">
                                            <div className="d-lg-flex text-center justify-content-lg-between">
                                                <span className="d-none d-lg-inline">قیمت  </span>
                                                <span>
                                                    <span className="text-xsmall"><Skeleton width={60}/> </span>
                                                </span>
                                            </div>
                                        </Col>
                                        <Col xs={4} lg={12} className="px-0 px-lg-3 py-lg-2">
                                            <div className="d-lg-flex text-center justify-content-lg-between">
                                                <span className="d-none d-lg-inline">تعداد  </span>
                                               
                                                    <span className="font-weight-bold">
                                                    <Skeleton width={60}/>
                                                    </span>
                                               
                                            </div>
                                        </Col>
                                        <Col xs={4} lg={12} className="text-center px-0 px-lg-3 py-lg-2">
                                            <div className="d-lg-flex text-center justify-content-lg-between">
                                                <span className="d-none d-lg-inline">قیمت کل  </span>
                                                <span className="font-weight-bold">
                                                    <span className="text-xsmall"><Skeleton width={60}/></span></span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>


                {/* repeat end */}

            </Col>

        </SkeletonTheme>
    )
}

export default SkeletonOrderDetail